import { fillArr, randomNum } from '@hglobal/common';
import {
  Transaction, TransactionChart, TransactionChartType, TransactionDirection, TransactionMetric,
  TransactionMetricTotal,
} from '@pt/models';

const CHART_IDS = ['income', 'expense', 'incomeExpense', 'receivedSent'];
const TEAM_CHART_IDS = ['receivedSent', 'receivedBurned'];

const METRICS = [
  { id: 'reward', direction: TransactionDirection.Income },
  { id: 'fromColleague', direction: TransactionDirection.Income },
  { id: 'refund', direction: TransactionDirection.Income },
  { id: 'purchase', direction: TransactionDirection.Expense },
  { id: 'toColleague', direction: TransactionDirection.Expense },
  { id: 'rollback', direction: TransactionDirection.Expense },
];

const TEAM_METRICS = [
  { id: 'received', direction: TransactionDirection.Income },
  { id: 'sent', direction: TransactionDirection.Expense },
  { id: 'burned', direction: TransactionDirection.Expense },
];

export function getTransactionsMock(forTeam: boolean, count = 12): Transaction[] {
  return fillArr(count, i => getTransaction(forTeam, i));
}

export function getTransaction(forTeam: boolean, id: number): Transaction {
  return {
    id,
    metric: forTeam
      ? TEAM_METRICS[randomNum(TEAM_METRICS.length - 1)].id
      : METRICS[randomNum(METRICS.length - 1)].id,
    createdAt: new Date().toString(),
    sum: id * 100,
    comment: [null, 'Comment'][randomNum(1)],
    user: [null, { id, fullName: `User ${id}` }][randomNum(1)],
  };
}

export function getTransactionMetricsMock(forTeam: boolean): TransactionMetric[] {
  return (forTeam ? TEAM_METRICS : METRICS).map(metric => ({
    id: metric.id,
    label: metric.id,
    name: metric.id,
    direction: metric.direction,
  }));
}

export function getTransactionChartsMock(forTeam: boolean, count = 3): TransactionChart[] {
  return fillArr(count, () => getTransactionChartMock(forTeam, '', randomNum(4, 2)));
}

export function getTransactionChartMock(
  forTeam: boolean,
  id?: string,
  metricsCount = 3,
): TransactionChart {
  return {
    id: (id || forTeam
      ? TEAM_CHART_IDS[randomNum(TEAM_CHART_IDS.length - 1)]
      : CHART_IDS[randomNum(CHART_IDS.length - 1)]) as TransactionChartType,
    metrics: getTransactionMetricTotalsMock(forTeam, metricsCount),
  };
}

export function getTransactionMetricTotalsMock(
  forTeam: boolean,
  count = 3,
): TransactionMetricTotal[] {
  return fillArr(count, () => getTransactionMetricTotalMock(forTeam));
}

export function getTransactionMetricTotalMock(
  forTeam: boolean,
  id?: string,
): TransactionMetricTotal {
  return {
    id: id || forTeam
      ? TEAM_METRICS[randomNum(TEAM_METRICS.length - 1)].id
      : METRICS[randomNum(METRICS.length - 1)].id,
    amount: randomNum(10) * 100,
  };
}
